import React from 'react';
import { Alert, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LegalLink from '../LegalLink';

const PromoAlert = () => (
  <Alert icon={<AutoAwesomeIcon fontSize="inherit" />} severity="info" sx={{ mt: 3 }}>
    <Typography variant="subtitle2" textAlign="left" sx={{ mb: 0.5 }}>
      Purchases using your ExpressWay credit card qualify for Special Financing!
      <sup>*</sup>
    </Typography>
    <Typography variant="body2" textAlign="left">
      Pay no interest if paid in full within 6 months on purchases or services
      of $350 or more. For more information see the
      {' '}
      <LegalLink href="https://app.dignifi.com/cardholder_agreement">
        WebBank DigniFi Credit Card Agreement
      </LegalLink>
      .
    </Typography>
  </Alert>
);

export default PromoAlert;
